import { useAuthStore } from '@/core/auth/auth.store';
import { Footer } from '@/shared/components/layout/Footer';
import React, { useEffect } from 'react';

const VitalSignsLimitPage = () => {
    const {topes, resetUser} = useAuthStore();
    const mensaje_conjunto = topes.mensaje_conjunto;

    // Página terminal: limpiar user para no arrastrar datos a una próxima sesión SSO.
    // topes ya se leyó arriba en el render inicial, así que el reset no afecta el mensaje.
    useEffect(() => {
        resetUser();
        sessionStorage.removeItem('vitalsProfile');
    }, [resetUser]);

    return (
        <>
            <div className="container-vitals">
                <section className="section-vitals form-vitals m-3">
                    <div className="title-vitals">
                        <i className="icon icon_enlinea_error"></i>
                        Acceso no disponible
                    </div>

                    <span className="text-vitals">
                        Has alcanzado el límite de usos disponibles para el chequeo de signos vitales incluido en tu plan.
                    </span>

                    <span className="text-vitals">
                        {mensaje_conjunto}
                    </span>
                    <span className="text-vitals">
                        Cierra esta pestaña para continuar.
                    </span>
                </section>
            </div>

            <Footer/>
        </>
    );
};

export { VitalSignsLimitPage };